<template>

<KeepAlive>


    <div class="search-container">
        <input 
    type="text"    
    v-model="currentValue"
    :autofocus="true"
    placeholder="search"
    :loading="isLoading"
    @keypress.enter.prevent >
        <i class="fa-brands fa-searchengin" v-if="!isLoading"></i>
        <img src="/assets/img/ring-spinner.svg" alt="spinner" v-else>
      </div>
</KeepAlive>
</template>

<script>
import { mapGetters } from 'vuex'
import {debounce} from 'lodash'

export default {
 
    props:{
        optionsData:{
            required:true,
            default:()=>{}
        }
    },
data(){
    return {
        currentValue:'',
        isLoading:false,
    }
},
computed:{
    ...mapGetters({paginateIndex:'getPaginationIndex'}),
},
methods:{
    debouncedEmit: debounce(async function(newValue) {

        this.$store.commit('setPaginationIndex',{currentIndex:1,currentDataGroupCount:0})
        if(newValue != ''){
            this.isLoading = true;
            await this.$store.dispatch(this.optionsData.actionName,{...this.optionsData.config, value:newValue,paginateIndex:this.paginateIndex})
            this.isLoading = false;
            this.$emit('searchBoxActive',newValue)

        }
        else {
            this.isLoading = true;
            
            let updatedConfig = {... this.optionsData.config};
            
            updatedConfig.paginateIndex = 1;

            await this.$store.dispatch(this.optionsData.defaultActionName,updatedConfig)
            this.isLoading = false;

            this.$emit('searchBoxActive','')

        }
    }, 500), // 500 milisaniye gecikme
},

watch:{
   
    async currentValue(newValue){
        this.debouncedEmit(newValue)
    }
},




}
</script>

<style scoped lang="scss">


.search-container {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    height: 3rem;
    position: relative;
    background: #fff;
    background: linear-gradient( 180deg, #ffffff 0%, #fafafe 100%);

    border-radius: 8px;
    border: 1px solid #3c305a2f;

    & input {
      width: 55%;
      height: max-content;
      border-bottom: 1.75px solid #3c305acc;
      font-size: .65rem;
      padding-right: 2rem;
      color: #3C305A;
      font-weight:500;
      outline: none;
      padding-bottom: .3rem;
      padding-top: .3rem;
      background: transparent;

      &::placeholder {
        color: #3c305ae9;
        font-weight: 550;
        font-family: "Open Sans";
      }
    }

    & i {
      position: absolute;
      right: 25%;
      top: 36%;
      font-size: 1rem;
      color: #3c305afb;
    }

    & img {
      position: absolute;
      right: 25%;
      top: 36%;
      height: 1rem;
      width: 1rem;
      object-fit: scale-down;
    }

  }
</style>

